export const environment = {
    NAME: "development",
    API: "https://dev-api.onsceneservices.com",
    TOKEN_KEY: 'oss-api-token',
    S3BUCKET: 'photo-capture-tester'
};
